import { useFocusEffect } from "expo-router";
import React, { useEffect, useState } from "react";
import ContentLoader, { Rect } from "react-content-loader/native";
import { useTranslation } from "react-i18next";
import { View, ScrollView, useWindowDimensions } from "react-native";
import { useDispatch } from "react-redux";

import Title from "@/components/Title";
import CustomersList from "@/components/management/CustomersList";
import { setForm } from "@/context/actions/actions";
import { useAppSelector } from "@/context/hooks";
import { sendRequest } from "@/utils/ApiUtil";

export default function Customers() {
  const [isLoading, setIsLoading] = useState(true);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const globalValues = useAppSelector((state: any) => state);
  const { height, width } = useWindowDimensions();

  useEffect(() => {
    getCustomer();
  }, []);

  const getCustomer = async () => {
    try {
      const request = await sendRequest("get", "/admin/customers", null, true);
      if (request) {
        dispatch(setForm({ customersData: request }));
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  useFocusEffect(
    React.useCallback(() => {
      dispatch(
        setForm({ currentMenuItem: t("management/home:menu.customers") }),
      );
      return () => {};
    }, []),
  );

  return (
    <ScrollView contentContainerClassName="flex-grow items-center px-4 py-2 bg-white1">
      <View className="flex-col w-full items-center">
        <View className="my-2">
          <Title text={t("management/home:title")} />
        </View>
        <View className="w-full items-center">
          {isLoading ? (
            <ContentLoader
              viewBox={`0 0 ${width} ${height}`}
              backgroundColor="#F9F9F9"
              foregroundColor="#E4E4E4"
            >
              <Rect x="0" y="0" rx="5" ry="5" width={width} height={height} />
            </ContentLoader>
          ) : (
            globalValues.customersData &&
            globalValues.customersData.length > 0 && (
              <CustomersList data={globalValues.customersData} />
            )
          )}
        </View>
      </View>
    </ScrollView>
  );
}
